export default [
    {
        title: 'Trendyol',
        icon: 'ShoppingBagIcon',
        children: [
            {
                title: 'Ürünler',
                route: 'trendyol',
                icon: 'ShoppingCartIcon',
            },
            {
                title: 'Ürün Arama Linki Ekle',
                icon: 'SearchIcon',
                route: 'trendyol-urun-ara',
            },
            {
                title: 'Ürün Açma',
                icon: 'BoxIcon',
                route: 'trendyol-urunacma',
            },
            {
                title: 'Tedarikçi Ürünleri Excel Listesi',
                icon: 'BoxIcon',
                route: 'trendyol-export-supplier-product',
            },
            {
                title: 'Eşleştirme',
                icon: 'BoxIcon',
                route: 'trendyol-eslestirme',
            },
            {
                title: 'Ürün Eşleştirme',
                icon: 'BoxIcon',
                route: 'trendyol-urun-eslestirme',
            },
            {
                title: 'Ürünler V2',
                icon: 'BoxIcon',
                route: 'trendyol-urunler-v2',
            },
            {
                title: 'Trendyol Ürün Yönetimi',
                icon: 'BoxIcon',
                route: 'trendyol-urun-yonetimi',
            },
        ],
    },
]
